import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface SiteState {
  siteName: string;
  siteId: string;

  timezone: string;
  shiftStart: string;

  siteStreet: string;
  siteCity: string;
  siteState: string;
  siteZip: string;
}

const initialState: SiteState = {
  siteName: '',
  siteId: '',

  timezone: '',
  shiftStart: '',

  siteStreet: '',
  siteCity: '',
  siteState: '',
  siteZip: '',
};

const currentSiteSlice = createSlice({
  name: 'currentSite',

  initialState,

  reducers: {
    setCurrentSite: (state, action: PayloadAction<SiteState>) => {
      return {
        ...state,
        ...action.payload,
      };
    },

    resetCurrentSite: () => initialState,
  },
});

export const { setCurrentSite, resetCurrentSite } = currentSiteSlice.actions;

export default currentSiteSlice.reducer;
